export const CodesFonctionnalites = {
  CARTO_NON_AODE: 'CARTO_NON_AODE',
  SDD_STANDARD: 'SERVICES_DE_DONNEES',
  SDD_ADMIN: 'SDD_ADMIN',
  CRAC: 'CRAC',
  INFO_TRAVAUX: 'INFO_TRAVAUX',
  INFO_COUPURES: 'INFO_COUPURES',
  RACCORDEMENTS: 'RACCORDEMENTS',
  TDB_CONCESSION: 'TDB_CONCESSION',
  CARTO_AODE: 'CARTO_AODE',
};
